'use client';

import DallasButton from '../Dallas/Buttons/DallasButton/DallasButton';
import DallasDialog from '../Dallas/Dialogs/DallasDialog';
import DallasImageAttractNewCarriers from '../Dallas/Images/AttractNewCarriers/DallasImageAttractNewCarriers';
import DallasStack from '../Dallas/Stack/DallasStack';
import DallasText from '../Dallas/Text/DallasText';
import { TRUCKSMARTER_SUPPORT_PHONE_NUMBER } from './phone-numbers';

interface Props {
  onClose?: () => void;
}

export default function ContactUsDialog({ onClose }: Props) {
  return (
    <DallasDialog
      onClose={onClose}
      padding="xl"
      header={
        <DallasStack direction="row" alignHorizontal="center">
          <DallasText variant="headerRegularS">Contact us</DallasText>
        </DallasStack>
      }
      content={
        <DallasStack>
          <DallasStack paddingVertical="2xl" alignHorizontal="center">
            <DallasImageAttractNewCarriers />
          </DallasStack>
          <DallasStack gap="2xl" alignHorizontal="center">
            <DallasText color="darkGray">
              Our team is available Monday to Friday from 8AM-6PM CT.
            </DallasText>
            <DallasText align="center" as="p">
              Phone: {TRUCKSMARTER_SUPPORT_PHONE_NUMBER} <br />
              Text: {TRUCKSMARTER_SUPPORT_PHONE_NUMBER}
            </DallasText>
            <DallasButton label="Done" onClick={onClose} color="primary" />
          </DallasStack>
        </DallasStack>
      }
    />
  );
}
